import Service, { service } from '@ember/service';
import type PartnerService from 'tio-employee/services/partner';

/** Beta surfaces use the resolved company palette or the native TIO recipe. */
export type BetaBrand = 'tio' | 'company';

export default class BetaBrandService extends Service {
  @service declare partner: PartnerService;

  get brand(): BetaBrand {
    return this.partner.publicTheme ? 'company' : 'tio';
  }
}

declare module '@ember/service' {
  interface Registry {
    'beta-brand': BetaBrandService;
  }
}
